// extracted by mini-css-extract-plugin
module.exports = {"amountCell":"amountCell__VXwlL"};